(() => {
  if (!window.CSS || !window.CSS.registerProperty) {
    return;
  }

  window.CSS.registerProperty({
    name: '--swinger-zoom',
    syntax: '<number>',
    inherits: false,
    initialValue: '0.001',
  });
})();
